module.exports = __webpack_public_path__ + "static/media/ham_gas_sur.9d8615ed.png";